module.exports = __webpack_public_path__ + "static/media/crescentaero.85a438e3.png";